export enum ERoles {
    USER = "USER",
    ADMIN = "ADMIN",
}

export enum ERoleLabels {
    USER = "Uživatel",
    ADMIN = "Administrátor",
}
